
import Router from './AllRoutes/Router';

import './App.css';

function App() {
  return (
    <div className="App">

      <Router />



    </div>
  );
}

export default App;
